var map = {
	"./1003 Model vs site PresVIDEO.mov": 107,
	"./1013-STEEL AND PRECAST PRES.mp4": 422,
	"./980.mp4": 2664,
	"./980PANELVIDEO.mp4": 5974
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5967;